export default __webpack_public_path__ + "static/media/huobi-btc.fd9ad2fa.png";